import React, { Component } from 'react';
import './Item.css'
import AdminPage from '../../admin/AdminPage'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['User']}</h3>
  			<AdminPage
          mode='account-setting'
        />
  		</div>
  	)
  }

}
 
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu7.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu7/Item.js